import { createId } from "@paralleldrive/cuid2";
export var PuzzleStatus;
(function (PuzzleStatus) {
    PuzzleStatus["Correct"] = "correct";
    PuzzleStatus["Incorrect"] = "incorrect";
    PuzzleStatus["Skipped"] = "skipped";
})(PuzzleStatus || (PuzzleStatus = {}));
// Helper class for creating quiz results
export class QuizResultFactory {
    static create(data, id) {
        return {
            ...data,
            id: id || createId(),
            createdAt: new Date(),
            updatedAt: new Date(),
        };
    }
}
// Helper class for creating puzzle attempts
export class PuzzleAttemptFactory {
    static create(data) {
        return {
            ...data,
            id: createId(),
            createdAt: new Date(),
            updatedAt: new Date(),
        };
    }
}
